module.exports = __webpack_public_path__ + "img/Weapon_15.a7c264bf.png";